import {
  LoginView,
  SsoView,
} from ".";

export const authRoutes = [
  {
    path: "/login",
    name: "login",
    meta: { layout: "empty", allowAnonymous: true },
    component: LoginView,
  },
  {
    path: "/sso/:token",
    name: "sso",
    meta: { layout: "empty", allowAnonymous: true },
    component: SsoView,
  },
];